export const UserExperimentsActionCreators = {
  resetGroups: () => ({
    type: "RESET_EXPERIMENTS_GROUPS",
  }),
  setGroups: (groups) => ({
    type: "SET_EXPERIMENTS_GROUPS",
    payload: groups,
  }),
};
